export function formatDate(raw: any): string {
  if (!raw) return "";
  let d: Date;
  if (raw?.toDate) {
    d = raw.toDate();
  } else if (raw?.seconds != null) {
    d = new Date(raw.seconds * 1000);
  } else if (raw?._seconds != null) {
    d = new Date(raw._seconds * 1000);
  } else {
    d = new Date(raw);
  }
  return d.toLocaleDateString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function formatCurrency(amount: number | undefined): string {
  if (amount == null) return "";
  return amount.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatPoints(points: number): string {
  return points.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/** Earn entries store the full Firestore doc ID; redeem entries store the short check id. */
export function getLoyaltyCheckRouteId(entry: {
  checkId?: string;
  salesPeriodId?: string;
}): string {
  if (!entry.checkId) return "";
  if (
    entry.salesPeriodId &&
    entry.checkId.startsWith(`${entry.salesPeriodId}-`)
  ) {
    return entry.checkId;
  }
  if (entry.salesPeriodId) {
    return `${entry.salesPeriodId}-${entry.checkId}`;
  }
  return entry.checkId;
}
